// extracted by mini-css-extract-plugin
module.exports = {"manaspan":"ManaString_manaspan__bZAyl","manacost":"ManaString_manacost__gMx2r"};